export const cleanupExistingLiveChatElements = (): void => {
  document.querySelectorAll('script').forEach(script => {
    const isTawkScript = script.src.includes('tawk.to');
    if (isTawkScript) script.remove();
  });

  document.querySelectorAll('iframe, div').forEach(el => {
    const isChatElement =
      el.id?.includes('tawk') ||
      el.className?.toLowerCase().includes('tawk') ||
      el.getAttribute('src')?.includes('tawk.to');

    if (isChatElement) el.remove();
  });
};